import { TCompilationType } from '../../../types/promosPage';
import {
  trackLastChanceDiscountClick,
  trackLastChanceDiscountShow,
  trackTopPromosClick,
  trackTopPromosShow,
} from '../tracking';

interface IAnalytics {
  trackAfterView: () => void;
  trackClick: () => void;
}

export function getPromoCompilationAnalytics(type: TCompilationType): IAnalytics {
  switch (type) {
    case 'topPromos':
      return {
        trackAfterView: trackTopPromosShow,
        trackClick: trackTopPromosClick,
      };
    case 'lastChanceDiscount':
      return {
        trackAfterView: trackLastChanceDiscountShow,
        trackClick: trackLastChanceDiscountClick,
      };
    default:
      return {
        trackAfterView() {},
        trackClick() {},
      };
  }
}
